import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { NavMarker } from 'react-rhumb';
import { Hero } from '../components/Hero';
import { ProductPageHeader } from '../components/headers/ProductPageHeader';
import { Screens } from '../constants/usage';
import { useGetSuggestionSections } from '../hooks/useGetSuggestionSections';
import { useSplitSuggestionSections } from '../hooks/useSplitSuggestionSections';
import { useTrackHomepageViewedEvent } from '../hooks/useTrackHomepageViewedEvent';
import { ProductHomeSections } from './components/ProductHomeSections';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function ProductPage({
  productType
}) {
  const pathKey = productType === 'APP' ? 'APPS' : 'AGENTS';
  const screen = productType === 'APP' ? Screens.APPS : Screens.AGENTS;
  const {
    error,
    loading,
    data
  } = useGetSuggestionSections();
  const {
    sections,
    remainingSections
  } = useSplitSuggestionSections({
    suggestionSections: data === null || data === void 0 ? void 0 : data.result.sections,
    start: 0,
    end: 2
  });
  useTrackHomepageViewedEvent({
    loading,
    screen,
    sections: data === null || data === void 0 ? void 0 : data.result.sections,
    type: productType
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [productType === 'APP' && /*#__PURE__*/_jsx(NavMarker, {
      name: "APPS_LOAD"
    }), productType === 'AGENT' && /*#__PURE__*/_jsx(NavMarker, {
      name: "AGENTS_LOAD"
    }), /*#__PURE__*/_jsx(UsageScreenProvider, {
      screen: screen,
      children: /*#__PURE__*/_jsxs(DashboardPage, {
        headerComponent: /*#__PURE__*/_jsx(ProductPageHeader, {
          pathKey: pathKey
        }),
        children: [/*#__PURE__*/_jsx(Hero, {
          text: `${productType} Hero`
        }), /*#__PURE__*/_jsx(ProductHomeSections, {
          productType: productType,
          loading: loading,
          error: error,
          sections: sections,
          remainingSections: remainingSections
        })]
      })
    })]
  });
}